// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"518c9006","498":"bd1c03a2","703":"22ae762c"}[chunkId] + ".chunk.js";
};